import React from 'react';
import HorecaLayout from './HorecaLayout';
import HorecaPresence from './components/horeca/horecapresence';
import ContactUsHoreca from './components/horeca/contactus2';



const HorecaContact = () => {


    return(<>
    <HorecaLayout>
     <ContactUsHoreca/>
     <HorecaPresence/>
    </HorecaLayout>
    </>);


}

export default HorecaContact;